<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link"
                :class="menu == 1 ? 'active' : ''"
                @click="menu = 1"
                id="empresa-tab"
                aria-controls="empresa"
                aria-selected="true"
                >Atualizar Dados da Empresa</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="params-tab"
                :class="menu == 2 ? 'active' : ''"
                @click="menu = 2"
                aria-selected="false"
                >Impressões</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="params-tab"
                :class="menu == 3 ? 'active' : ''"
                @click="menu = 3"
                aria-selected="false"
                >Tolerância</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="params-tab"
                :class="menu == 4 ? 'active' : ''"
                @click="menu = 4"
                aria-selected="false"
                >Adicional Noturno</a
              >
            </li>
          </ul>

          <div v-if="posto !== '' && menu == 1" class="col-12">
            <FormPostoTrabalho
              :tipo="tipo"
              :posto="posto"
              @salvarPostoTrabalho="salvarDados"
            />
          </div>

          <div v-if="menu == 2" class="col-12">
            <FormParametrizacao
              :tipo="tipo"
              :parametros="parametros"
              @salvarParametrizacao="salvarParametros"
            />
          </div>
          <div v-if="menu == 3" class="col-12">
            <FormTolerancia
              :tipo="tipo"
              :parametros="parametros"
              @salvarTolerancia="salvarToleranciaCLT"
            />
          </div>
          <div v-if="menu == 4" class="col-12">
            <FormAdicionalNoturno
              :tipo="tipo"
              :parametros="parametros"
              @salvarAdicional="salvarAdicionalNoturno"
            />
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BasePagination, BaseInput } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import NotificationHorarioLimite from "./Notifications/NotificationHorarioLimite.vue";
import FormPostoTrabalho from "./PostosTrabalho/FormPostoTrabalho.vue";
import FormParametrizacao from "./PostosTrabalho/FormParametrizacao.vue";
import FormTolerancia from "./PostosTrabalho/FormTolerancia.vue";
import FormAdicionalNoturno from "./PostosTrabalho/FormAdicionalNoturno.vue";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseInput,
    FormPostoTrabalho,
    FormParametrizacao,
    FormTolerancia,
    FormAdicionalNoturno,
  },
  data() {
    return {
      menu: 1,
      tipo: "",
      posto: "",
      isLoading: false,
      parametros: "",
    };
  },
  created() {
    this.carregarDados();
    this.carregarParametros();
  },
  mounted() {},
  methods: {
    notifyVue(verticalAlign, horizontalAlign) {
      this.$notify({
        component: NotificationHorarioLimite,
        icon: "tim-icons icon-bell-55",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: "warning",
        timeout: 30000,
      });
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    carregarDados() {
      const th = this;
      this.tipo = 2;

      const bodyFormData = {
        setDB: this.$cookies.get("db"),
        idEmpregador: 1,
      };

      this.axios
        .post("/api/empregador/selecionarEmpregadorPorId", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          if (response.data.data.dados.length > 0) {
            const dados = response.data.data.dados[0];
            this.posto = dados;
            this.posto.cpf_cnpj = this.formatarCpfCnpj(dados.cpf_cnpj);
          }
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar buscar os dados da empresa!",
            "error",
          );
        });
    },

    carregarParametros() {
      const th = this;

      const bodyFormData = {
        setDB: this.$cookies.get("db"),
      };

      this.axios
        .post("/api/parametrizacao/listarParametrizacao", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          if (response.data.dados.status) {
            th.parametros = response.data.dados.dados[0];
            console.log(th.parametros);
          }
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar parametros da empresa!",
            "error",
          );
        });
    },

    formatarCpfCnpj(valor) {
      if (valor.length === 14) {
        valor = valor.padStart(14, "0");
        valor = valor.replace(
          /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5",
        );
      } else {
        valor = valor.padStart(11, "0");
        valor = valor.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      }

      return valor;
    },

    salvarDados(event) {
      const th = this;
      let url = `/api/empregador/cadastrarEmpregador`;
      let msg = `cadastrar`;
      event.setDB = this.$cookies.get("db");

      if (this.tipo === 2) {
        url = `/api/empregador/editarEmpregador`;
        msg = `editar`;
      }

      this.axios
        .post(url, event, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          console.log(response);
          th.isLoading = false;
          window.location.reload();
          th.showSwal(
            "auto-close",
            "Sucesso",
            `Sucesso ao atualizar dados da empresa!`,
            "success",
          );
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            `Erro ao atualizar dados da empresa!`,
            "error",
          );
        });
    },
    salvarParametros(event) {
      this.parametros.imprimirAbono = event.imprimirAbono;
      this.parametros.imprimirAbonoBH = event.imprimirAbonoBH;
      this.parametros.imprimirOcorrencia = event.imprimirOcorrencia;
      this.parametros.imprimirBatidasManuais = event.imprimirBatidasManuais;
      this.parametros.imprimirFeriado = event.imprimirFeriado;

      const th = this;
      const url = `/api/parametrizacao/atualizarParametrizacao`;

      const bodyFormData = { ...this.parametros, setDB: event.setDB };
      this.axios
        .post(url, bodyFormData)
        .then((response) => {
          th.isLoading = false;
          window.location.reload();
          th.showSwal(
            "auto-close",
            "Sucesso",
            `Sucesso ao atualizar parâmetros da empresa!`,
            "success",
          );
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            `Erro ao atualizar parâmetros da empresa!`,
            "error",
          );
        });
    },
    salvarToleranciaCLT(event) {
      this.parametros.toleranciaClt = event.toleranciaClt;

      const th = this;
      const url = `/api/parametrizacao/atualizarParametrizacao`;

      const bodyFormData = { ...this.parametros, setDB: event.setDB };
      this.axios
        .post(url, bodyFormData)
        .then((response) => {
          th.isLoading = false;
          window.location.reload();
          th.showSwal(
            "auto-close",
            "Sucesso",
            `Sucesso ao atualizar parâmetros da empresa!`,
            "success",
          );
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            `Erro ao atualizar parâmetros da empresa!`,
            "error",
          );
        });
    },
    salvarAdicionalNoturno(event) {
      this.parametros.inicioHoraNoturna = event.inicioHoraNoturna;
      this.parametros.fimHoraNoturna = event.fimHoraNoturna;
      this.parametros.fatorNoturno = event.fatorNoturno;
      this.parametros.intervaloNotuno = event.intervaloNotuno;
      this.parametros.extenderTerminoJornada = event.extenderTerminoJornada;

      const th = this;
      const url = `/api/parametrizacao/atualizarParametrizacao`;

      const bodyFormData = { ...this.parametros, setDB: event.setDB };
      this.axios
        .post(url, bodyFormData)
        .then((response) => {
          th.isLoading = false;
          window.location.reload();
          th.showSwal(
            "auto-close",
            "Sucesso",
            `Sucesso ao atualizar parâmetros da empresa!`,
            "success",
          );
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            `Erro ao atualizar parâmetros da empresa!`,
            "error",
          );
        });
    },
  },
  watch: {},
};
</script>
<style>
.divCorpoDialog {
  padding: 0px;
  margin-top: -25px;
}
</style>
